var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-snotify"),
      _vm._v(" "),
      _c("loading-indicator", {
        attrs: {
          sync: _vm.$store.getters.shouldLoadFullPage,
          "full-page": true
        }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "component-fade", mode: "out-in" } },
        [_c(_vm.layout, { tag: "component" }, [_c("router-view")], 1)],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }